import React from 'react'

import type { AbFtData } from './util/useAbFtData'


export const AbFtContext = React.createContext<AbFtData>(null)

export type { AbFtData } from './util/useAbFtData'

export default AbFtContext
